/**
 * Site Configuration
 * 
 * This file controls the visibility of pages and sections throughout the site.
 * Set any feature to `false` to hide it from the site while keeping the code intact.
 */

export const siteConfig = {
  // Page visibility
  pages: {
    home: true,
    about: true,
    team: false,          // Team is now merged into About page
    projects: true,       // Now includes competitions/events
    sponsors: false,      // Deactivated but ready to reactivate
    events: false,        // Merged into Projects page
    contact: true,
  },

  // Section visibility on Home page
  home: {
    hero: true,
    features: true,
    gallery: true,
    upcomingEvents: true,
    callToAction: true,
  },

  // Section visibility on About page
  about: {
    mission: true,
    values: true,
    team: true,           // Team section within About page
    callToAction: true,
  },

  // Section visibility on Projects page
  projects: {
    projectCards: true,
    competitions: true,   // Includes events/competitions
    achievements: true,
    statistics: true,
    callToAction: true,
    researchPapers: false,  // Commented out per requirements
  },

  // Footer sections
  footer: {
    quickLinks: {
      about: true,
      projects: true,
      contact: true,
      team: false,         // Hidden since merged into About
      events: false,       // Hidden since merged into Projects
      sponsors: false,     // Hidden since deactivated
    },
    socialLinks: true,
    contactInfo: true,
  },
}

export default siteConfig
